// 渠道账户一体化，判断是不是正常的账户一体化域名，还是定制域名的渠道
// true是正常的，false是定制域名
export const filterHost = () => {
  // 恒实定制渠道，直接认定为正常的账户一体化域名
  if (isHS()) return true
  const currentHost = window.location.host
  const currentHref = window.location.href
  const includesArray = ['customReportBlank', 'reportConfig', 'previewReportConfig', 'overallFinancingService', 'overallProduct', 'overallProductSort']
  if (isIncludes(currentHref, includesArray)) {
    return false
  }
  // 是不是正常的账户一体化域名
  if (currentHost.includes('enterpriseservice.cn') || currentHost.includes('wfq2020.com') || currentHost.includes('ceecpj')) {
    return true
  }
  // 本地调试用的，想调试哪个就返回什么值
  // true就是调试正常的，false调试定制域名
  if (currentHost.includes('localhost')) {
    return false
  }
  return false
}

const isIncludes = (str, targetArray) => {
  for (let i = 0; i < targetArray.length; i++) {
    if (str.includes(targetArray[i])) {
      return true
    }
  }
  return false
}

// 是不是恒实定制渠道
export const isHS = () => {
  return window.location.href.includes('https://dqbg.crediths.com') || window.location.href.includes('testHS=true')
}
